/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateRegistrationVatConsistencyRequest
 */
export interface ValidateRegistrationVatConsistencyRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateRegistrationVatConsistencyRequest
     */
    registrationNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateRegistrationVatConsistencyRequest
     */
    vatNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateRegistrationVatConsistencyRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateRegistrationVatConsistencyRequest
     */
    regionCode?: string;
}

/**
 * Check if a given object implements the ValidateRegistrationVatConsistencyRequest interface.
 */
export function instanceOfValidateRegistrationVatConsistencyRequest(value: object): value is ValidateRegistrationVatConsistencyRequest {
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('vatNumber' in value) || value['vatNumber'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ValidateRegistrationVatConsistencyRequestFromJSON(json: any): ValidateRegistrationVatConsistencyRequest {
    return ValidateRegistrationVatConsistencyRequestFromJSONTyped(json, false);
}

export function ValidateRegistrationVatConsistencyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateRegistrationVatConsistencyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'registrationNumber': json['registrationNumber'],
        'vatNumber': json['vatNumber'],
        'countryCode': json['countryCode'],
        'regionCode': json['regionCode'] == null ? undefined : json['regionCode'],
    };
}

export function ValidateRegistrationVatConsistencyRequestToJSON(value?: ValidateRegistrationVatConsistencyRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'registrationNumber': value['registrationNumber'],
        'vatNumber': value['vatNumber'],
        'countryCode': value['countryCode'],
        'regionCode': value['regionCode'],
    };
}

